/**
 * The Wishful "wish sparkle" mark — a white four-point sparkle on a rounded Sky tile.
 *
 * This is the SVG source of truth from ../listful-api/docs/BRAND.md, the same shape
 * used for the favicon, the PWA icons and the iOS app icon. Rendered inline rather
 * than as an <img> so it stays crisp at any size and can inherit sizing from the
 * caller. If the glyph changes, change it in BRAND.md first and mirror it here.
 */
export default function WishfulMark({ className = 'w-10 h-10', title = 'Wishful' }) {
    return (
        <svg
            className={className}
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
        >
            <rect width="512" height="512" rx="120" fill="#0284c7" />
            <path
                d="M256 96 C 276 214, 298 236, 416 256 C 298 276, 276 298, 256 416 C 236 298, 214 276, 96 256 C 214 236, 236 214, 256 96 Z"
                fill="#ffffff"
            />
        </svg>
    );
}
